export default __webpack_public_path__ + "static/media/logo-blue.078a5d84.png";